import { useEffect, useId, useState } from 'react'
import { AccrualItem, ITutorReceiptItem, tutorService } from '../../../entities/tutor'
import { FEATURES, hasFeature, useMyActions } from '../../../entities/my'
import { useAppSelector } from '../../../app/store/store'
import { AddReceipt } from '../../../features/addReceipt'
import { AuthError } from '../../../shared/lib/error/AuthError'
import { MyError } from '../../../shared/lib/error/MyError'
import { LoaderSpinner } from '../../../shared/ui/spinner'
import classes from './myPayouts.module.scss'

interface IProps {
    refreshKey?: number;
    defaultOpen?: boolean;
    onReceiptSaved?: () => void;
}

export const MyPayouts = ({refreshKey = 0, defaultOpen = false, onReceiptSaved}: IProps) => {
    const {my} = useAppSelector(s => s.myReducer)
    const canCreateReceipt = hasFeature(my, FEATURES.TUTORS.RECEIPTS_CREATE, my.id)
    const [open, setOpen] = useState(defaultOpen)
    const [items, setItems] = useState<ITutorReceiptItem[]>([])
    const [loading, setLoading] = useState(defaultOpen)
    const [error, setError] = useState('')
    const [retry, setRetry] = useState(0)
    const contentId = useId()
    const {setIsAuth} = useMyActions()

    const saveReceipt = (id: string) => () => {
        setItems(current => current.map(item =>
            item.id === id ? {...item, hasReceipt: true} : item
        ))
        onReceiptSaved?.()
    }

    useEffect(() => {
        if(!open) return
        let active = true
        setLoading(true)
        setError('')
        tutorService.listMyPayouts()
            .then(payouts => {
                if(active) setItems(payouts)
            })
            .catch(e => {
                if(!active) return
                if(e instanceof AuthError) setIsAuth(false)
                setError(e instanceof MyError || e instanceof AuthError
                    ? e.message : 'Не удалось загрузить выплаты')
            })
            .finally(() => {
                if(active) setLoading(false)
            })
        return () => { active = false }
    }, [open, refreshKey, retry, setIsAuth])

    return (
        <section className={classes.container}>
            <button type="button" className={classes.toggle} aria-expanded={open}
                aria-controls={contentId} onClick={() => setOpen(value => !value)}>
                Все мои выплаты
                <svg className={open ? classes.open : ''} width="19" height="11" viewBox="0 0 19 11" aria-hidden="true">
                    <path d="m1 1 8.5 8.5L18 1" fill="none" stroke="currentColor" strokeWidth="2" />
                </svg>
            </button>
            {open && <section id={contentId} className={classes.content} aria-busy={loading}>
                {loading ? <LoaderSpinner /> : error ? <div role="alert">
                    <p>{error}</p>
                    <button type="button" onClick={() => setRetry(value => value + 1)}>Повторить</button>
                </div> : items.length ? items.map(item => (
                    <AccrualItem key={item.id} accrual={{
                        id: item.id, date: item.createdAt, amount: item.amount,
                        comment: item.comment, is_receipt: item.hasReceipt,
                    }}>
                        {canCreateReceipt && !item.hasReceipt ? (
                            <AddReceipt accrualId={item.id} onSaveTrigger={saveReceipt(item.id)} />
                        ) : <span>не загружен</span>}
                    </AccrualItem>
                )) : <p className={classes.empty}>Выплат пока нет</p>}
            </section>}
        </section>
    )
}
